import { PageRecord } from "../../recordDefinition.types";

export const isActiveAccount = (record: PageRecord) => record.statecode === 0;
